export default __webpack_public_path__ + "static/13-a025dbe1a6ade532f6078c0c18428a12.png";